<mat-card-content>
  <h1 class="titulo-simpli">{{title}}</h1>
  <div class="subtitulo-simpli"></div>

  <div class="badge-ceo-new mt10">

    <div class="box-badge animate__animated animate__fadeIn">
      <div class="label-user-box-badge">
        <span>${{totalGanancia | formatting:'money'}}</span>
      </div>
      <div class="label-box-badge">Ganancias</div>
    </div>

    <div class="box-badge animate__animated animate__fadeIn">
      <div class="label-user-box-badge">
        <span>{{rentabilidad | formatting:'rate'}}</span>
      </div>
      <div class="label-box-badge">Rentabilidad</div>
    </div>

  </div>



  <div id="container-retiro-hoy" class="mt10">

  </div>

</mat-card-content>